import { render, staticRenderFns } from "./Recorder.vue?vue&type=template&id=b1f1e2a6&scoped=true&"
import script from "./Recorder.vue?vue&type=script&lang=js&"
export * from "./Recorder.vue?vue&type=script&lang=js&"
import style0 from "./Recorder.vue?vue&type=style&index=0&id=b1f1e2a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f1e2a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1f1e2a6')) {
      api.createRecord('b1f1e2a6', component.options)
    } else {
      api.reload('b1f1e2a6', component.options)
    }
    module.hot.accept("./Recorder.vue?vue&type=template&id=b1f1e2a6&scoped=true&", function () {
      api.rerender('b1f1e2a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/session/Recorder.vue"
export default component.exports